export const mercadopago = {
  publicKey: 'APP_USR-7ee64f6e-11a9-461b-8ff6-05d41842f22d',
  get: 'v1/card_tokens',
};
